export function downloadBlobFile(data: Blob, fileName: string) {
  const blob = new Blob([data], { type: 'application/vnd.ms-excel' });
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a') as HTMLAnchorElement;
  a.href = objectUrl;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(objectUrl);
}
